import React from "react";
import styled from "styled-components";
// Components
// import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/rent_car.png";
import LinkButton from "../Buttons/LinkButton";

export default function Services() {
  return (
    <Wrapper id="services">
      
      <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={ProjectImg1} alt="add" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h2 className="font40 extraBold">Our Services</h2>
              <p className="font12">
              Experience Freedom on Wheels with Aussie Everest. Our premium car rental and hire service is designed to redefine your travel adventures. With a fleet of meticulously maintained vehicles, we offer the perfect ride for every occasion.
              </p>
              <ButtonsRow className="flexFullLeft">
                <div style={{ width: "290px" }}>
                  <LinkButton title="Mister Smoky Restaurant" href="https://mistersmoky.com.au" target="_blank" border/>
                </div>
                <div style={{ width: "190px"}}>
                  <LinkButton title="Hire a Car" href="https://hire.aussieverest.com" target="_blank" />
                </div>
                <div style={{ width: "190px" }}>
                  <LinkButton title="Rent a Car" href="https://rent.aussieverest.com" target="_blank" border/>
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  @media (max-width:860px) {
    margin-bottom: 20px;
  }
`;
// const HeaderInfo = styled.div`
//   @media (max-width: 860px) {
//     text-align: center;
//   }
// `;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 800px) {
    padding: 0;
  }
`;
